export default __webpack_public_path__ + "static/media/Japan_Particle_0012_TenkoBall_2.71bb5a5d.png";